const CustomImage = ({ src, alt, classname, width, height }) => {
  return (
    <img
      className={classname}
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      onError={(e) => {
        e.currentTarget.src = "/avatar-placeholder.png";
      }}
    />
  );
};

export default CustomImage;
